module.exports = __webpack_public_path__ + "static/img/gywmEn.1465221b.png";